<iot-platform-ui-country-autocomplete
  (selectionChange)="onSelectionChange($event)"
  [disableOnlyOptions]="true"
  [disabled]="disabled()"
  [filterType]="$safeNavigationMigration(data()?.filterType)"
  [placeholder]="$safeNavigationMigration(data()?.placeholder)"
/>
